<script setup>
import { useSlots } from 'vue';

// eslint-disable-next-line no-undef
const props = defineProps({
    label: {
        type: String,
        required: false,
    },
    required: {
        type: Boolean,
        required: false,
    },
    modelValue: {
        type: String,
        default: '',
    },
});

const slot = useSlots();

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue']);
</script>

<template>
    <div class="tw-flex tw-flex-col tw-justify-end v-input-calendar">
        <label v-if="props.label" class="!tw-text-[1.2em] tw-font-semibold">
            {{ props.label }}
            <span v-if="props.required" class="tw-text-red-700">*</span>
        </label>
        <div class="tw-flex tw-items-center tw-gap-x-4 tw-py-2 tw-px-4 container-icon-input">
            <div v-if="slot.icon">
                <slot name="icon" />
            </div>
            <Calendar
                :required="props.required"
                :modelValue="props.modelValue"
                @update:modelValue="emit('update:modelValue', $event)"
                class="tw-w-full"
                dateFormat="d M yy"
            />
        </div>
    </div>
</template>

<style scoped>
.container-icon-input {
    /*TODO: seems like the utility class is acting weird*/
    /*@apply tw-border-b tw-border-primary tw-border-solid;*/
    border-bottom: 1px solid #FF0090;
}
</style>